module.exports = __webpack_public_path__ + "static/media/social.6616406a.png";